<script setup lang="ts">
import { useFetchGeneral } from '~/api/service/general/index.service'
import HomeChartTitle from '~/components/@pages/home/HomeChartTitle.vue'
import LineChart from '~/components/chart/LineChart.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import IconTooltip from '~/components/tooltip/IconTooltip.vue'
import { HOME_CHART_TOOLTIP, HOME_REFETCH_PARAMS } from '~/constants/general.const'
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { generalParamType } from '~/types/general.type'

const { data, isLoading } = useFetchGeneral([ generalParamType.INTERNAL_TRANSACTION, generalParamType.PENDING_TRANSACTION ])
const { data: countData, isLoading: countLoading } = useFetchGeneral(HOME_REFETCH_PARAMS)

const pendingChartList = computed(() => {
  if (!data.value) return []
  return data.value.FPTI.OBJ.DTRXLIST.map(i => {
    return [ i.UT, i.TRXCNT ]
  })
})

const internalChartList = computed(() => {
  if (!data.value) return []
  return data.value.FITI.OBJ.DTRXLIST.map(i => {
    return [ i.UT, i.TRXCNT ]
  })
})

const pendingTotalCount = computed(() => {
  if (!countData.value) return ''
  return setComma(countData.value.FPTTCNTI.OBJ.TTRXCNT)
})

const internalTotalCount = computed(() => {
  if (!countData.value) return ''
  return setComma(countData.value.FITTCNTI.OBJ.TTRXCNT)
})
</script>

<template>
  <div>
    <CustomSuspense :is-loading="isLoading || countLoading">
      <template #loading>
        <img
          :src="`${IMAGE_BASE_URL}/skeleton/home/two-line-chart.png`"
          alt="line chart skeleton"
        >
      </template>
      <template #default>
        <!--        <div class="etc-txn-container">-->
        <Card class="flex flex-col justify-between gap-y-8">
          <div class="flex flex-col gap-y-2 px-5 pt-5">
            <HomeChartTitle
              title="Internal Txns"
              :tooltip="HOME_CHART_TOOLTIP[generalParamType.INTERNAL_TRANSACTION_TOTAL_COUNT]"
            />
            <strong class="text-3xl text-primary">{{ internalTotalCount }}</strong>
          </div>
          <LineChart
            :height="164"
            line-color="#4feab2"
            gradient-color="#3FFFBA"
            :data="internalChartList"
            :formatter="(params) => {
              return `<p class='text-center'><span class='text-white/40'>${params[0].name}</span><br />Internal Transactions: ${setComma(params[0].value)}</p>`
            }"
          />
        </Card>
        <!--          <Card class="flex flex-col justify-between pt-5">-->
        <!--            <div class="px-5">-->
        <!--              <span class="block font-bold text-primary/40">Pending Txns</span>-->
        <!--              <strong class="text-2xl text-primary">{{ pendingTotalCount }}</strong>-->
        <!--            </div>-->
        <!--            <LineChart-->
        <!--              :height="160"-->
        <!--              line-color="#ff74fd"-->
        <!--              gradient-color="#ff74fd88"-->
        <!--              :data="pendingChartList"-->
        <!--              :formatter="(params) => {-->
        <!--                return `<p class='text-center'><span class='text-white/40'>${params[0].name}</span><br />Pending Transactions: ${setComma(params[0].value)}</p>`-->
        <!--              }"-->
        <!--            />-->
        <!--          </Card>-->
        <!--        </div>-->
      </template>
    </CustomSuspense>
  </div>
</template>

<style scoped lang="scss">
.etc-txn-container {
  display: grid;
  //grid-template-columns: 1fr 1fr;
  //grid-gap: 20px;
  width: 100%;
  height: 100%;
}
</style>